import api from "@/assets/js/api";
import { clientApi } from "@/assets/js/websocketFunctions";

const mixins = {
  data() {
    return {
      cert: ""
    };
  },
  methods: {
    // 校验客户端
    validateKey: function(signData) {
      var _this = this;
      _this.$xLoading.show();
      // 使用 WebSocket API 检测客户端（获取签名证书）
      clientApi({ command: 101, code: 5, parameter: ['1'] })
        .then(function(res) {
          console.log(res.error, "请求");
          if (res.error == 0) {
            _this.usbkeySign();
          } else {
            _this.$message.error("未检测到KEY，请您先插入KEY再进行签章！");
            _this.$xLoading.close();
          }
        })
        .catch(function(error) {
          _this.$message.error(error);
          console.log("异步调用返回失败:", error);
          _this.$xLoading.close();
        });
    },
    // 校验key
    usbkeySign: function() {
      var _this = this;
      _this.$xLoading.show();
      // 使用 WebSocket API 获取签名证书
      clientApi({ command: 101, code: 5, parameter: ['1'] })
        .then(function(json) {
          var error = json.error;
          if (error == 0) {
            var certbytes = json.parameter[0];
            _this.cert = certbytes;
            _this.getSignImageList(_this);
          } else {
            _this.$message.error("获取证书数据失败，请检查是否插key！");
            _this.$xLoading.close();
          }
        })
        .catch(function(error) {
          // certSign();//软证书签
          _this.$xLoading.close();
        });
    },
    mixinSoftParamsFn: function(sealType, data) {
      console.log(sealType, data);
      const subSealObj = {
        get_type: data.getType + "", // 转String
        get_info: {
          user_id:
            (sealType.toString() === "1" || (sealType.toString() === "2" && data.getSealUserInfoVO.sealTypeCode === '099'))
              ? data.getSealUserInfoVO.orgId
              : data.getSealUserInfoVO.userId,
          uums_user_id:
            (sealType.toString() === "1" || (sealType.toString() === "2" && data.getSealUserInfoVO.sealTypeCode === '099'))
              ? data.getSealUserInfoVO.uumsOrgId
              : data.getSealUserInfoVO.uumsId,
          use_user_id: data.getSealUserInfoVO
            ? data.getSealUserInfoVO.userId
            : "",
          use_uums_user_id: data.getSealUserInfoVO
            ? data.getSealUserInfoVO.uumsId
            : ""
        },
        seal_nature: data.getSealUserInfoVO.sealTypeCode
      };
      console.log(subSealObj, "softParamsFn");
      return subSealObj;
    },
    getPorjectConfig: function() {
      api.menu.getProjectName().then(res => {
        console.log(res, "????");
        sessionStorage.setItem("aesKey", res.data.data.aesKey);
        if (res.data.data.UMSPChgPsw) {
          sessionStorage.setItem("UMSPChgPsw", res.data.data.UMSPChgPsw);
        }
        document.getElementsByTagName("title")[0].innerHTML =
          res.data.data.projectName;
      });
    }
  }
};
export default mixins;




// WEBPACK FOOTER //
// ./src/mixins/index.js